import { render, staticRenderFns } from "./BaseSecondary.vue?vue&type=template&id=846a14ca&"
import script from "./BaseSecondary.vue?vue&type=script&lang=ts&"
export * from "./BaseSecondary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports